import { XCircleIcon } from "@heroicons/react/20/solid";
import React from "react";

const AlertError: React.FC<{
  title?: string;
  description?: React.ReactNode;
}> = ({ description, title }) => {
  return (
    <div className="bg-red-50 p-4 border border-red-200 rounded-md">
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon className="w-5 h-5 text-red-500" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="font-medium text-sm text-red-800">{title ?? "Add Title"}</h3>
          <div className="mt-2 text-sm text-red-700">{description ?? "Add Description"}</div>
        </div>
      </div>
    </div>
  );
};

export default AlertError;
